import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
    {
        id: 1,
        name: 'Alexander Sterling',
        role: 'Collector',
        text: "The attention to detail is unmatched. My Patek Philippe arrived in pristine condition, and the service was nothing short of exceptional.",
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1887&auto=format&fit=crop'
    },
    {
        id: 2,
        name: 'Isabella Vance',
        role: 'Fashion Director',
        text: "LuxeTime isn't just a store; it's a curated experience. They helped me find the perfect vintage Cartier for my collection.",
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop'
    },
    {
        id: 3,
        name: 'Marcus Thorne',
        role: 'Entrepreneur',
        text: "Efficiency, elegance, and exclusivity. I've purchased three timepieces here, and I wouldn't trust anyone else.",
        image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop'
    }
];

const Testimonials = () => {
    return (
        <section className="section-padding bg-luxury-blue relative">
            <div className="container mx-auto">
                <div className="text-center mb-16">
                    <h3 className="text-luxury-gold uppercase tracking-widest mb-2">Client Stories</h3>
                    <h2 className="text-4xl md:text-5xl font-serif font-bold text-luxury-black">Reflections of Excellence</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((item) => (
                        <div key={item.id} className="glass-card p-8 rounded-xl relative group hover:-translate-y-2 transition-transform duration-300">
                            <Quote className="w-10 h-10 text-luxury-gold/20 absolute top-6 right-6" />

                            <div className="flex items-center gap-1 mb-6">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} className="w-4 h-4 text-luxury-gold fill-luxury-gold" />
                                ))}
                            </div>

                            <p className="text-gray-600 mb-8 italic leading-relaxed">"{item.text}"</p>

                            <div className="flex items-center gap-4">
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="w-12 h-12 rounded-full object-cover border-2 border-luxury-gold/20"
                                />
                                <div>
                                    <h4 className="font-serif font-bold text-luxury-black">{item.name}</h4>
                                    <p className="text-xs text-luxury-gold uppercase tracking-wide">{item.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
